import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BlogStore {
  selectedBlog: string;
  setSelectedBlog: (blog: string) => void;
}

export const useBlogStore = create<BlogStore>()(
  persist(
    (set) => ({
      selectedBlog: '',
      setSelectedBlog: (blog) => set({ selectedBlog: blog }),
    }),
    {
    name: 'blog-storage',
    }
  )
);

interface DraftStore {
  forms: Record<string, any>;
  getForm: <T>(formId: string) => T | undefined;
  setForm: (formId: string, data: any) => void;
  resetForm: (formId: string) => void;
}

export const useDraftStore = create<DraftStore>()(
  persist(
    (set, get) => ({
      forms: {},
      getForm: (formId) => get().forms[formId],
      setForm: (formId, data) =>
        set((state) => ({
          forms: { ...state.forms, [formId]: data },
        })),
      resetForm: (formId) =>
        set((state) => {
          const newForms = { ...state.forms };
          delete newForms[formId];
          return { forms: newForms };
        }),
    }),
    {
      name: 'draft-storage',
    }
  )
);
